exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".upgrade-settings__description{margin-bottom:16px;line-height:20px}.upgrade-settings__list{margin-top:16px;padding-left:16px;list-style:none}.upgrade-settings__list-item{line-height:24px}.upgrade-settings__dialog-path{font-weight:700;margin:16px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/pages/upgrade-settings/upgrade-settings.scss
// module id = 817
// module chunks = 0